import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '../services/login.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class CanActivateChildGuardGuard implements CanActivateChild {

  constructor(private loginService: LoginService, private router: Router, private toastr: ToastrService) { };

  canActivateChild() {

    if (!this.loginService.userIsLogged()) {
      //console.log('No estas logueado');
      this.router.navigate(['/']);
      return false;
    } else {//*Si hay un token en localStorage pero ya expiró
      if (this.loginService.isTokenExpired()) {
        this.showWarningMessage('La sesión ha expirado!', 'Sesión expirada');
        this.loginService.logout();
        this.router.navigate(['/']);
        return false;
      }
    }

    return true;
  }

  showSuccessMessage(mensaje: string, titulo: string) {
    this.toastr.success(mensaje, titulo);
  }

  showErrorMessage(mensaje: string, titulo: string) {
    this.toastr.error(mensaje, titulo);
  }

  showInfoMessage(mensaje: string, titulo: string) {
    this.toastr.info(mensaje, titulo);
  }

  showWarningMessage(mensaje: string, titulo: string) {
    this.toastr.warning(mensaje, titulo);
  }

}
